import { render } from "./SignUpForm.vue?vue&type=template&id=731e41a0"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"
script.render = render

export default script